import axios from '../axios/redditlikeApi'

const getVotes = () => axios.get('/vote')

const getVoteByPostId = postId => axios.get(`/vote/post/${postId}`)

const updatePostVote = (postId, vote) => axios.patch(`/vote/post/${postId}/${vote}`)

const updateCommentVote = (commentId, vote) => axios.patch(`/vote/comment/${commentId}/${vote}`)

export default {
  getVotes,
  getVoteByPostId,
  updatePostVote,
  updateCommentVote
}
